import { PropsWithChildren } from "react";
import { Box, Stack } from "@mui-wrapper";
import { SphereXgLogo } from "@flat-ui";
import { useMediaQueries } from "@hooks/use-media-queries";
import { NavLink } from "react-router-dom";
import { resetLoginState } from "@store/login/login-slice";
import { useAppDispatch } from "@store/store-helper";

/**
 * Unified Login Mask (ULM) container
 */
export function UlmContainer({ children }: PropsWithChildren): JSX.Element {
  const { isSmallHeightScreen } = useMediaQueries();
  const dispatch = useAppDispatch();

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 440,
          minWidth: 200,
          margin: "10px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Stack
          direction="column"
          sx={{
            alignItems: "center",
            width: "inherit",
            marginTop: isSmallHeightScreen ? "0" : "80px",
          }}
        >
          <Box
            component={NavLink}
            to={"/login"}
            onClick={() => {
              dispatch(resetLoginState());
            }}
          >
            <SphereXgLogo height="4.25rem" />
          </Box>

          {children}
        </Stack>
      </Box>
    </Box>
  );
}
